import useLocalStorage from '@onepercentio/one-ui/hooks/persistence/useLocalStorage'
import { useWebviewIntegration } from 'context/WebviewIntegration'
import useRouteGalleryOrDefault from 'openspace/hooks/useRoutePathGallery'
import { useEffect, useLayoutEffect } from 'react'
import { updateThemeColor } from 'utility/tags'

export default function HTMLTagUpdater() {
  const gallery = useRouteGalleryOrDefault()
  const { setThemeColor } = useWebviewIntegration()
  /** A fallback color for when the gallery is not loaded yet  */
  const [fallbackColor, setFallbackColor] = useLocalStorage(
    'fallback-color',
    ''
  )
  const colorToSet = gallery?.predominantColor || fallbackColor
  useLayoutEffect(() => {
    if (colorToSet) {
      const oldColor = updateThemeColor(colorToSet)
      setThemeColor({
        background: colorToSet,
        foreground: '#ffffff',
      })
      return () => {
        updateThemeColor(oldColor)
        setThemeColor({
          background: oldColor,
          foreground: '#ffffff',
        })
      }
    }
  }, [colorToSet])

  useEffect(() => {
    if (gallery?.predominantColor) setFallbackColor(gallery.predominantColor)
  }, [gallery])

  return null
}
